import React from "react";
import "./AnswerCard.scss";

export default function AnswerCard(props) {
  const { answerTitle, indexString, handleAnswerClick, correct, incorrect, isAnswered, index } = props;

  return (
    <div
      className={`answer_container ${correct ? "correct" : incorrect ? "incorrect" : ""}`}
      onClick={() => {
        if (!isAnswered) handleAnswerClick(index + 1);
      }}
    >
      <div className="answer_title">
        <div className="answer_index ">{indexString}</div>
        {answerTitle}
      </div>
      <p className="answer_status">{isAnswered && "30% got correct"}</p>
    </div>
  );
}
